<template>
  <div style="height: 100%;">
    <el-row style="margin-bottom:10px;height: 30px;" class="flex">
      <el-col :span="4" v-if="theProjectId== 0" >
        <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="form.getType" @change="thetimechange" size="small" clearable placeholder="请选择时间段">
          <el-option v-for="item in timeType" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8">
        <el-date-picker size="small" v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" @change="selectTime" value-format="yyyy-MM-dd">
        </el-date-picker>
      </el-col>
      <el-col :span="2" v-if="form.dtLevel">
        <el-button @click="toExport"  type="primary"  size='small' style='margin-left:10px;'>导出团队数据
        </el-button>
      </el-col>
      <span style="font-size: 14px;color:#909399;margin: 5px 10px;">注:'双击'图表所在区域,可使图表放大,'单击'取消</span>
    </el-row>


    <div
      style="width: 100%;display: flex;flex-wrap: wrap;justify-content: space-around;align-content:space-around;height: calc(100% - 60px);margin-bottom: 20px;"
      v-if="form.projectId"
      >
      <div  :class="[maxRef == 'echartsStr1'?'maxMask':'echartsBox']" @click="refClick">
        <div ref="eCharts1"  :class="[maxRef == 'echartsStr1'?'maxDiv':'divcss']"  @dblclick="maxClick('echartsStr1')">

        </div>
      </div>
      <div  :class="[maxRef == 'echartsStr2'?'maxMask':'echartsBox']" @click="refClick">
        <div ref="eCharts2" :class="[maxRef == 'echartsStr2'?'maxDiv':'divcss']"  @dblclick="maxClick('echartsStr2')">

        </div>
      </div>
      <div  :class="[maxRef == 'echartsStr3'?'maxMask':'echartsBox']" @click="refClick">
        <div ref="eCharts3" :class="[maxRef == 'echartsStr3'?'maxDiv':'divcss']"  @dblclick="maxClick('echartsStr3')">

        </div>
      </div>
      <div  :class="[maxRef == 'echartsStr4'?'maxMask':'echartsBox']" @click="refClick" >
        <div ref="eCharts4" :class="[maxRef == 'echartsStr4'?'maxDiv':'divcss']"  @dblclick="maxClick('echartsStr4')">

        </div>
      </div>
      <div :class="[maxRef == 'echartsStr5'?'maxMask':'echartsBox']" @click="refClick">
        <div ref="eCharts5" :class="[maxRef == 'echartsStr5'?'maxDiv':'divcss']"  @dblclick="maxClick('echartsStr5')">

        </div>
      </div>
      <div :class="[maxRef == 'echartsStr6'?'maxMask':'echartsBox']" @click="refClick">
        <div ref="eCharts6" :class="[maxRef == 'echartsStr6'?'maxDiv':'divcss']"  @dblclick="maxClick('echartsStr6')">

        </div>
      </div>
    </div>

   
  </div>
</template>

<script>
  import qs from 'qs';
  import axios from 'axios';
  import echarts from 'echarts'
  export default {
    data() {
      return {
        isMax:false,
        maxRef:'',
          baseUrl: $Api.baseUrl_online,
        echartsStr1: '',
        echartsStr1Value: [],
        echartsStr2: '',
        echartsStr2Value: {
          xdata: [],
          data: []
        },
        echartsStr3: '',
        echartsStr3Value: {
          xdata: [],
          data: []
        },
        echartsStr4: {
          data: [],
          xdata: [],
        },
        echartsStr4Value: [],
        echartsStr5: '',
        echartsStr5Value: {
          xdata: [],
          data: []
        },
        echartsStr6: '',
        echartsStr6Value: {
          xdata: [],
          data: []
        },
        value1: '',
        theUserProject: '',
        theProjectId: '',
        form: {
          projectId: '',
          getType: '',
          startDate: '',
          endDate: '',
          dtLevel: ''
        },
        timeType: [{
            label: "全部",
            value: 1
          },
          {
            label: "今日",
            value: 2
          },
          {
            label: "本周",
            value: 3
          },
          {
            label: "本月",
            value: 4
          },
        ],
        color: [
          ' #4992ff',
          ' #dd79ff',
          ' #fddd60',
          '  #ff6e76',
          ' #58d9f9',
          ' #05c091',
          '  #ff8a45',
          ' #8d48e3',
        ],
      }

    },
    mounted(){
      const _this = this
       window.addEventListener('resize',function() {
         _this.echartsStr1.resize()
          _this.echartsStr2.resize()
           _this.echartsStr3.resize()
            _this.echartsStr4.resize()
            _this.echartsStr5.resize()
            _this.echartsStr6.resize()
       });
    },
    methods: {
      refClick(){
        const ref =this.maxRef
        this.maxRef = '';
        this.$nextTick(()=>{
          this.DrawEcharts();
          this[ref].resize()
        })
      },
      // 最大化
      maxClick(ref){
        console.log(ref);
        this.maxRef = ref
        this.$nextTick(()=>{
          this.DrawEcharts();
        this[ref].resize()
        })
       
      },
      // 导出
      openLoading() {
        //loading请求等待
        this.loading = this.$loading({
          lock: true,
          text: "加载中...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
      },
      toExport: async function() {
        const that = this;

        var s = qs.stringify(that.form);
        that.openLoading();
        axios({
          method: 'post',
          url: that.baseUrl + '/opportunity/ou-statistics/exportStatisticsDepartment',
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: 'arraybuffer',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
          }
        }).then(function(response) {
          that.loading.close();
          let a = document.createElement('a');
          //ArrayBuffer 转为 Blob
          let blob = new Blob([response.data], {
            type: "application/vnd.ms-excel"
          });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", '团队.xlsx');
          a.click();
          that.$message({
            message: "成功",
            type: "success"
          });
        }).catch(function(error) {
          that.loading.close();
          console.log(error);
        });
      },

      // 图标配置项
      DrawEcharts() {
        console.log(this.$refs.eCharts1)
        this.echartsStr1 = this.$echarts.init(this.$refs.eCharts1)
        this.echartsStr1.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 客户建档',
            left: '3%',
            top: "3%"
          }, //标题位置
          tooltip: {
            trigger: 'item'
          }, //提示框组件 ---数据项图形触发
          legend: {
            orient: 'vertical', //图标列表的布局朝向
            right: '3%',
            top:'2%'
          },
          series: [{
            name: '客户建档',
            type: 'pie',
            radius: '70%',
            data: this.echartsStr1Value,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        })
        this.echartsStr2 = this.$echarts.init(this.$refs.eCharts2)
        this.echartsStr2.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 企业拜访',
            left: '3%',
            top: "3%"
          }, //标题位置
          tooltip: {
            trigger: 'axis'
          }, //提示框组件 ---数据项图形触发
          legend: {
            // orient: 'vertical', //图标列表的布局朝向
            left: 'right',
            data: this.echartsStr2Value.xdata

          },
          xAxis: {
            type: 'category',
            data: this.echartsStr2Value.xdata,
            axisLabel:{
              interval:0,
              margin:10,
              rotate:30
            },
          },
          yAxis: {
            type: 'value'
          },
          series: [{

            type: 'bar',
            radius: '80%',
            data: this.echartsStr2Value.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        })
        this.echartsStr3 = this.$echarts.init(this.$refs.eCharts3)
        this.echartsStr3.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 签约单数',
            left: '3%',
            top: "3%"
          }, //标题位置
          tooltip: {
            trigger: 'axis'
          }, //提示框组件 ---数据项图形触发
          legend: {
            // orient: 'vertical', //图标列表的布局朝向
            left: 'right',
            data: this.echartsStr3Value.xdata

          },
          xAxis: {
            type: 'category',
            boundaryGap: true,
            data: this.echartsStr3Value.xdata,
            axisLabel:{
              interval:0,
              margin:10,
              rotate:30
            },
          },
          yAxis: {
            type: 'value'
          },
          series: [{

            type: 'line',
            radius: '80%',
            data: this.echartsStr3Value.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }],
        })
        this.echartsStr4 = this.$echarts.init(this.$refs.eCharts4)
        this.echartsStr4.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 签约金额(总金额)',
            left: '3%',
            top: "3%"
          }, //标题位置

           tooltip: {
             trigger: 'item',

           }, //提示框组件 ---数据项图形触发
          legend: {
            // orient: 'vertical', //图标列表的布局朝向
            right: '3%',
            top: "3%",
            data: ['签约金额']

          },
          radar: {
            // shape: 'circle',
            indicator: this.echartsStr4Value.data
          },
          series: [{

            type: 'radar',
            radius: '80%',
            data: [{
                value: this.echartsStr4Value.xdata,
                name: '签约金额'
              },

            ],

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }],
        })
        this.echartsStr5 = this.$echarts.init(this.$refs.eCharts5)
        this.echartsStr5.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 完成率(%)',
            left: '3%',
            top: "3%"
          }, //标题位置
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
        
              return params[0].marker + params[0].name + ':' + '</br>' + params[0].value +'%'
            }
          }, //提示框组件 ---数据项图形触发
          legend: {
            // orient: 'vertical', //图标列表的布局朝向
            left: 'right',
            data: this.echartsStr5Value.xdata

          },
          xAxis: {
            type: 'category',
            data: this.echartsStr5Value.xdata,
            axisLabel:{
              interval:0,
              margin:10,
              rotate:30
            },
          },
          yAxis: {
            type: 'value'
          },
          series: [{

            type: 'bar',
            radius: '80%',
            data: this.echartsStr5Value.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        })
        this.echartsStr6 = this.$echarts.init(this.$refs.eCharts6)
        this.echartsStr6.setOption({
          darkMode: ' auto',
          colorBy: 'series',
          color: this.color,
          // backgroundColor: '#100C2A',
          title: {
            text: '· 破零率(%)',
            left: '3%',
            top: "3%"
          }, //标题位置
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
           
              return params[0].marker + params[0].name + ':' + '</br>' + params[0].value +'%'
            }
          }, //提示框组件 ---数据项图形触发
          legend: {
            // orient: 'vertical', //图标列表的布局朝向
            left: 'right',
            data: this.echartsStr6Value.xdata

          },
          xAxis: {
            type: 'category',
            data: this.echartsStr6Value.xdata,
            axisLabel:{
              interval:0,
              margin:10,
              rotate:30
            },
          },
          yAxis: {
            type: 'value'
          },
          series: [{

            type: 'bar',
            radius: '80%',
            data: this.echartsStr6Value.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }]
        })
      },

      // 获取图标数据
      getEcharts() {
        this.echartsStr1Value = [];
        this.echartsStr2Value = {
          xdata: [],
          data: []
        }
        this.echartsStr3Value = {
          xdata: [],
          data: []
        }
        this.echartsStr4Value = {
          xdata: [],
          data: []
        } 
        this.echartsStr5Value = {
          xdata: [],
          data: []
        }
        this.echartsStr6Value = {
          xdata: [],
          data: []
        }
        var maxNum='';
        this.getStatisticsDepartment(this.form).result(res => {
          res.data.data.forEach((item, index) => {
            this.echartsStr1Value.push({
              value: item.customerNum,
              name: item.dtName
            })
            this.echartsStr2Value.xdata.push(item.dtName)
            this.echartsStr2Value.data.push(item.visitorNum)
            this.echartsStr3Value.xdata.push(item.dtName)
            this.echartsStr3Value.data.push(item.userOrderNum)
            this.echartsStr4Value.xdata.push(item.userKpi)

            this.echartsStr4Value.data.push({
              name: item.dtName,
              max:maxNum
            })
            this.echartsStr5Value.xdata.push(item.dtName)
            this.echartsStr5Value.data.push(item.userKpiComplete)
            this.echartsStr6Value.xdata.push(item.dtName)
            this.echartsStr6Value.data.push(item.userKpiGreaterThanZero)
          })
           maxNum = Math.max(... this.echartsStr4Value.xdata)
            this.echartsStr4Value.data.forEach(item=>{
              item.max = maxNum
            })
          this.DrawEcharts()
        });

      },
      theDtChange(e) {
        this.form.dtLevel = e
        this.getEcharts()

      },
      selectTime(e) {
        this.form.startDate = e[0]
        this.form.endDate = e[1]
        this.form.getType = '';
        this.getEcharts()
      },
      thetimechange(e) {
        this.form.getType = e;
        this.form.startDate = '';
        this.form.endDate = ''
        this.getEcharts()

      },
      theProjectAllChange(e) {
        if(e == ''){
          return  this.form.projectId = e;
        }
        this.form.projectId = e;
        this.getEcharts()
      },
    },
    created() {
      this.getProjectList({
        pageSize: 0
      });

      this.theProjectId = A.local("$projectId");
      if (this.theProjectId != 0) {
        this.form.projectId = this.theProjectId;
      }

    }

  }
</script>

<style scoped>
.maxMask{
  height: 100vh;width: 100vw;position: fixed;top:0;left: 0;background-color: rgba(0, 0, 0, 0.3);z-index: 999;
}
.maxDiv{
  width: 90%;height: 95%;margin: 2% auto;background-color: white;border-radius: 20px;overflow: hidden;
}
.divcss{
  width: 100%;height: 100%;
}
  .echartsBox {
    width:33%;
    border: 1px solid black;
    height: 46%;
    margin: 15px 0;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/views/data/TeamAnalysis.vue